export default __webpack_public_path__ + "static/media/vittas-mobile-mock.597805be.png";